import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import useForm from "../../Lib/form/useForm";
import ValidatedInput from "../../Lib/form/Components/ValidatedInput/ValidatedInput";
import Card from "../../Lib/material-dashboard/components/Card/Card";
import CardBody from "../../Lib/material-dashboard/components/Card/CardBody";
import ValidatedSubmit from "../../Lib/form/Components/ValidatedSubmit/ValidatedSubmit";
import {useSnackbar} from "notistack";
import Grid from "@material-ui/core/Grid";

import accountStyle from "./accountStyle";
import Button from "../../Lib/material-kit/components/CustomButtons/Button";
import {makeStyles} from "@material-ui/styles";
import FormProvider from "../../Lib/form/Components/FormProvider/FormProvider";
import {PasswordRecord, PasswordSchema} from "../../Data/account";
import {resetCredentials} from "../../Api/accounts";
import Section from "../../Lib/form/Components/Section/Section";
import ContentBox from "../../Components/ContentBox/ContentBox";
import {LoginButton} from "./Accounts";
import {closeSnack} from "../../Main/util";

const useStyles = makeStyles(accountStyle);

/**
 * Checks if the password verification is the same as password.
 */
export const passwordValidator = (fieldName, fieldValue, fieldValues) => {
  return fieldValues["newPassword"] === fieldValue;
};

const ResetFinish = ({id, token}) => {

  const [success, setSuccess] = useState(false);

  const {enqueueSnackbar, closeSnackbar} = useSnackbar();

  const api = (record, onSuccess, onError) => {
    resetCredentials(id, record, onSuccess, onError)
  };

  const cbSuccess = () => {
    setSuccess(true);
  };

  const cbError = () => {
    enqueueSnackbar(
        t('reset-finish-error'),
        {variant: 'warning', persist: true, action: (key) => closeSnack(t, closeSnackbar, key)});
  };

  const {t} = useTranslation("accounts");

  // noinspection JSPotentiallyInvalidConstructorUsage
  const form = useForm({
    recordType: PasswordRecord,
    recordSchema: PasswordSchema,
    namespace: 'accounts',
    record: new PasswordRecord({ oldPassword: token })
  });

  const classes = useStyles();

  if (success) {
    return (
        <ContentBox title={t("reset-finish-success")}>
          <Section title={t("reset-finish-success")}>
            <br/>
            {t('reset-finish-success-explanation')}
            <LoginButton t={t} classes={classes}/>
          </Section>
        </ContentBox>
    )
  }

  return (
        <div className={classes.panel}>
          <Card className={classes.container}>
            <CardBody>
              <Grid container justify="center">

                <Grid item xs={12}>
                  <div className={classes.title}>{t('reset-finish-title')}</div>
                  <p>{t('reset-finish-explanation')}</p>
                </Grid>

                <Grid item xs={12}>
                  <FormProvider form={form} formClassName={classes.form}>
                    <ValidatedInput name="oldPassword" password label="secret"/>
                    <ValidatedInput name="newPassword" password/>
                    <ValidatedInput name="verification" password validator={passwordValidator}/>

                    <Grid item container justify="space-between">
                      <Grid item style={{marginTop: 40}}>
                        <ValidatedSubmit
                            api={api}
                            hideCancel
                            submitLabel={t('reset-finish-button')}
                            onSuccess={cbSuccess}
                            onError={cbError}
                        />
                      </Grid>
                      <Grid item style={{marginTop: 40}}>
                        <Button color="info">
                          {t('general:back')}
                        </Button>
                      </Grid>
                    </Grid>
                  </FormProvider>
                </Grid>

              </Grid>
            </CardBody>
          </Card>
        </div>
  );
};

export default ResetFinish;